export default __webpack_public_path__ + "static/Imme_1.2-b57dd9e7659282ee28e273a1eafc6c9e.png";